import { styled } from 'styled-components'

import { LoadingContainer, Model, Modal } from 'peach/components'
import { useParams } from 'peach/router'

import { Page } from 'core/components'
import { isNotFoundError, R } from 'core/helpers'
import {
  useInternalLoanGet,
  useInternalLoanAutopayGet,
  useInternalLoanAutopayPost,
  useInternalLoanAutopayPut,
} from 'core/types'

const LoanAutopay = () => {
  const { companyId, personId, loanId } = useParams<{
    companyId?: string
    personId?: string
    loanId?: string
  }>()

  const {
    data: loan,
    isLoading: loanLoading,
    error: loanError,
    refetch: refetchLoan,
  } = useInternalLoanGet({ companyId, personId, loanId })

  const {
    data: autopay,
    isLoading: autopayLoading,
    error: autopayError,
    refetch: refetchAutopay,
  } = useInternalLoanAutopayGet({
    companyId,
    personId,
    loanId,
    options: {
      throwOnError: !R.isNot(isNotFoundError),
    },
  })

  const { mutateAsync: updateAutopay } = useInternalLoanAutopayPut({
    companyId,
    personId,
    loanId,
  })

  const { mutateAsync: createAutopay } = useInternalLoanAutopayPost({
    companyId,
    personId,
    loanId,
  })

  const createInstallmentAutopay = (
    <Modal
      initialValue={{}}
      onSubmit={async (options) => {
        await updateAutopay(options)
        await refetchLoan()
        await refetchAutopay()
      }}
      title='Create Installment Autopay'
    />
  )

  const createLineOfCreditAutopay = (
    <Modal
      initialValue={{}}
      onSubmit={async (options) => {
        await createAutopay(options)
        await refetchLoan()
        await refetchAutopay()
      }}
      title='Create Line of Credit Autopay'
    />
  )

  const modals =
    loan?.type === 'installment'
      ? createInstallmentAutopay
      : loan?.type === 'lineOfCredit'
      ? createLineOfCreditAutopay
      : null

  const isLoading = loanLoading || autopayLoading
  const error = loanError ?? autopayError

  return (
    <LoadingContainer error={error} loading={isLoading}>
      {modals}
      <Page variant='full'>
        {autopay ? (
          <Model.Item json={autopay} />
        ) : (
          <NoAutopayMessage>No autopay set on loan.</NoAutopayMessage>
        )}
      </Page>
    </LoadingContainer>
  )
}

export default LoanAutopay

const NoAutopayMessage = styled.div`
  color: ${({ theme }) => theme.text};
`
